module.exports = __webpack_public_path__ + "img/frio-blanco.3cbb8c6a.svg";